import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

// msal.js library is responsible for user authentication.
// Importing msal config. The instance will be passed to the app as param.
const msalInstance = new PublicClientApplication(msalConfig);

// Setting up API endpoint.
axios.defaults.baseURL = process.env.REACT_APP_API_URI;

ReactDOM.render(
  <React.StrictMode>
    <App instance={msalInstance} />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
